// extracted by mini-css-extract-plugin
export default {"resume":"CYc0YeXUkw2586jOiqiS","resumeItem":"V0HvA2Y6JwenRNR_G5t8"};